/* unplugin-vue-components disabled */import script from "./authPage.vue?vue&type=script&setup=true&lang=js"
export * from "./authPage.vue?vue&type=script&setup=true&lang=js"

import "./authPage.vue?vue&type=style&index=0&id=3570e3e6&lang=less&scoped=true"
import "./authPage.vue?vue&type=style&index=1&id=3570e3e6&lang=stylus&scoped=true"

import exportComponent from "E:\\work\\AirLink-html\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3570e3e6"]])

export default __exports__